import COUNTRIES from '../countries.translations'

import translations from './aluminium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/aluminium'

export const aluminium: Metal = {
  id: 6,
  slug: 'aluminium',
  name: t.name,
  symbol: 'Al',
  mines: [
    {
      name: 'Sangarédi (Guinea, CBG)',
      region: t.mine0Region,
      slug: 'sangaredi',
      coordinates: [-13.77, 11.1],
    },
    {
      name: 'Paragominas & Trombetas (Brazil, Vale)',
      region: t.mine1Region,
      slug: 'paragominas-trombetas',
      coordinates: [-49.6, -3.31],
    },
    {
      name: 'Darling Range (Australia, Alcoa)',
      region: t.mine2Region,
      slug: 'darling-range',
      coordinates: [116.07, -32.27],
    },
    {
      name: 'Weipa (Australia, Rio Tinto)',
      region: t.mine3Region,
      slug: 'weipa',
      coordinates: [141.88, -12.63],
    },
  ],
  countries: [
    { name: COUNTRIES.guinea, percent: 28.9 },
    { name: COUNTRIES.australia, percent: 22.2 },
    { name: COUNTRIES.china, percent: 20.7 },
    { name: COUNTRIES.brazil, percent: 7.3 },
    { name: COUNTRIES.india, percent: 5.6 },
  ],
  // Gallium is recovered from the bauxite that aluminium is refined from.
  related: ['gallium'],
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'battery', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 5, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
          credit: 'Chinaface / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Aluxum / Getty',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
